import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ProgressBarModule } from 'primeng/progressbar';
import { Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ImportMarcacionesService } from '../../../core/services/conf/import-marcaciones.service';
import { BiometricAttendanceService } from '../../../core/services/api/biometric-attendance.service';

@Component({
    selector: 'app-import-marcaciones-modal',
    standalone: true,
    imports: [CommonModule, ButtonModule, DialogModule, ProgressBarModule],
    templateUrl: './import-marcaciones-modal.component.html'
})
export class ImportMarcacionesModalComponent implements OnInit, OnDestroy {
    private importMarcacionesService = inject(ImportMarcacionesService);
    private biometricAttendanceService = inject(BiometricAttendanceService);
    private subscription?: Subscription;

    visible = false;
    progress = 0;
    finished = false;
    failed = false;
    errorMsg = '';
    summaryText = '';
    private timer?: ReturnType<typeof setInterval>;

    ngOnInit(): void {
        this.subscription = this.importMarcacionesService.open$.subscribe(() => this.startImport());
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
        this.stopTimer();
    }

    get closed(): boolean {
        return this.finished || this.failed;
    }

    startImport(): void {
        this.stopTimer();
        this.progress = 0;
        this.finished = false;
        this.failed = false;
        this.errorMsg = '';
        this.summaryText = '';
        this.visible = true;

        this.timer = setInterval(() => {
            if (this.progress < 95) {
                this.progress = Math.min(95, this.progress + Math.floor(Math.random() * 8) + 4);
            }
        }, 300);

        this.biometricAttendanceService
            .getAttendance()
            .pipe(switchMap((payload) => this.biometricAttendanceService.importAttendance(payload)))
            .subscribe({
                next: (res: any) => {
                    this.stopTimer();
                    this.progress = 100;
                    this.finished = true;
                    const data: any = res?.data ?? {};
                    const branch = data?.branchName ? ` en ${data.branchName}` : '';
                    this.summaryText = `Se importaron ${data?.schedulesSaved ?? 0} horarios para ${data?.personsMatched ?? 0} persona(s)${branch}.`;
                },
                error: (err: any) => {
                    this.stopTimer();
                    this.failed = true;
                    this.errorMsg = err?.error?.message || err?.message || 'No se pudieron importar las marcaciones';
                }
            });
    }

    closeModal(): void {
        if (this.closed) {
            this.visible = false;
        }
    }

    private stopTimer(): void {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = undefined;
        }
    }
}
